<template>
  <div>
    <section-title
      class="col-12 mt-2 mb-2 pl-0"
      :has-line="false"
      :title="'Información General'"
    />
    <div class="row mb-4 pl-3">
      <div class="col-sm">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="data.rupNumber"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Número de RUP:"
            type="number"
          />
        </validation-provider>
      </div>
      <div class="col-sm">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="data.phoneNumber"
            :custom-error-msg="validationMessages.required"
            :error="errors[0]"
            label="Teléfono:"
            mask-type="Phone"
            placeholder="(___) ___-____"
          />
        </validation-provider>
      </div>
      <div class="col-sm">
        <custom-input
          v-model="data.faxNumber"
          label="Fax:"
          mask-type="Phone"
          placeholder="(___) ___-____"
        />
      </div>
      <div class="col-sm">
        <custom-input
          v-model="data.website"
          label="Dirección Web:"
          placeholder="www.websitedomain.com"
        />
      </div>
      <div class="col-sm">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="data.stateDeptRegistration"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Registro del Departamento de Estado:"
            type="number"
          />
        </validation-provider>
      </div>
      <div class="col-sm">
        <custom-input
          v-model="data.supplierSite"
          label="Supplier Site:"
          maxlength="10"
        />
      </div>
    </div>
    <div class="row align-items-center mb-4 pl-3">
      <div v-if="!isIndividualCompany" class="col-xm">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-radio
            v-model="data.profitType"
            custom-error-msg="Este campo es requerido"
            :error="errors[0]"
            is-inline
            label="Tipo de Proveedor:"
            name="profitType"
            :options="profitTypeOptions"
            @input="resetLegalSuffixes"
          />
        </validation-provider>
      </div>
      <div v-if="data.profitType == 1" class="col-xm">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="data.legalSuffix"
            :clearable="false"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Designación Corporativa:"
            :options="legalsuffixes"
          />
        </validation-provider>
      </div>
    </div>
    <div v-if="isIndividualCompany" class="row mb-4 pl-3">
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="data.specialty"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Especialidad:"
            maxlength="100"
          />
        </validation-provider>
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-input
            v-model="data.licenseNumber"
            :custom-error-msg="errors[0]"
            :error="errors[0]"
            label="Número de Licencia:"
            maxlength="50"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomRadio from '@/components/common/CustomRadio';
import CustomDropDown from 'custom-drop-down';
import { CustomInput } from '@/components/common';
import companyTypes from '@/utils/constants/companyTypes.js';

export default {
  name: 'ProviderGeneralInfo',
  components: {
    SectionTitle,
    CustomRadio,
    CustomInput,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          rupNumber: '',
          profitType: '',
          ssn: '',
          companyTypeName: '',
          companyName: '',
          website: '',
          phoneNumber: '',
          faxNumber: '',
          companyTypeId: null,
          specialty: '',
          licenseNumber: '',
          legalSuffix: '',
          stateDeptRegistration: '',
          supplierSite: '',
        };
      },
    },
  },
  data() {
    return {
      data: this.value,
      profitTypeOptions: [
        { value: 1, label: 'Con Fines de Lucro' },
        { value: 2, label: 'Sin Fines de Lucro ' },
      ],
      legalsuffixes: [
        { id: 1, name: 'LLC.' },
        { id: 2, name: 'Corp.' },
        { id: 3, name: 'Inc.' },
        { id: 4, name: 'PSC.' },
      ],
    };
  },
  computed: {
    validationMessages() {
      return {
        required: 'Campo Requerido',
      };
    },
    isIndividualCompany() {
      return this.value.companyTypeId == companyTypes.Individual;
    },
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.data = newValue;
        if (
          this.data.legalSuffix &&
          typeof this.data.legalSuffix === 'string'
        ) {
          this.data.legalSuffix = this.legalsuffixes.find(
            (x) => x.name === this.data.legalSuffix
          );
        }
      },
    },
  },
  methods: {
    resetLegalSuffixes() {
      this.data.legalSuffix = null;
    },
  },
};
</script>
